import {Layer} from '../../../service/Layer'

// Action para adicionar uma coluna ao SELECT
const addColumn = async (context, column, aggregation = 'none') => {
  const select = context.state.layers[context.state.activeLayerId].draft.select
  let foundKey = column.hasOwnProperty('id') ? column.id : column.objectId
  foundKey = column.hasOwnProperty('targetId') && column.targetId !== -1 ? column.targetId : foundKey
  const columnIndex = select.findIndex(c => c.id === foundKey)
  if (columnIndex !== -1) return false
  const newColumn = {
    'id': foundKey,
    'useAlias': false,
    'aggregation': aggregation,
    'useInternalName': true,
    'isSystem': true
  }
  const columns = [...select, newColumn];
  context.commit('setColumns', columns);
}

// Action para remover uma coluna do SELECT
const removeColumn = async (context, column) => {
  const draft = context.state.layers[context.state.activeLayerId].draft
  const select = draft.select
  let foundKey = column.hasOwnProperty('id') ? column.id : column.objectId
  foundKey = column.hasOwnProperty('targetId') && column.targetId !== -1 ? column.targetId : foundKey
  const columnIndex = select.findIndex(c => c.id === foundKey)
  if (columnIndex !== -1) select.splice(columnIndex, 1)
  if (select.length === 1) {
    const groupIndex = draft.groupBy.findIndex(c => c.id === select[0].id)
    if (groupIndex !== -1) draft.groupBy.splice(groupIndex, 1)
  }
  context.commit('setColumns', select);
}

const activateLayer = (context, layerId) => {
  context.commit("initializeLayer", layerId)
  context.commit("setActiveLayer", layerId)
}

const saveLayer = async (context, payload) => {
  return new Promise((resolve, reject) => {
    const backEnd = Layer.build({})
    backEnd.update(payload).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        context.commit('setFeatureLayer', payload)
        resolve(res)
      }
    }).catch(error => {
      console.log(error)
      reject(error)
    })
  })
}
const setBaseLayer = async (context, payload) => {
  context.state.baseLayer = payload
  if (payload !== null) {
    if (payload.cClass === 'userdraw') return false
    const layerId = payload.objectid
    const backEnd = Layer.build({})
    await backEnd.getPrimaryKey(layerId).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        context.state.basePk = res.data[0]
      }
    })
  }
}
const setTargetLayer = async (context, payload) => {
  context.state.targetLayer = payload
  if (payload !== null) {
    if (payload.cClass === 'userdraw') return false
    const layerId = payload.objectid
    const backEnd = Layer.build({})
    await backEnd.getPrimaryKey(layerId).then((res) => {
      if (res.status >= 200 && res.status < 300) {
        context.state.targetPk = res.data[0]
      }
    })
  }
}

export default {
  activateLayer,
  addColumn,
  removeColumn,
  saveLayer,
  setBaseLayer,
  setTargetLayer
}
